import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './styles.scss.js';

const BaseWithUtils = (superClass) => {
    var _a;
    class CompWithUtils extends superClass {
    }
    CompWithUtils.styles = [
        (_a = superClass.styles) !== null && _a !== void 0 ? _a : [],
        css_248z,
    ];
    __decorate([
        n({ type: String })
    ], CompWithUtils.prototype, "utilityClasses", void 0);
    return CompWithUtils;
};

export { BaseWithUtils };
